<jqxWindow #form [theme]="environment.tema" [width]="180" [showCloseButton]="true" [showCollapseButton]="true"
    [zIndex]="90" [height]="120" [resizable]="false" [position]="getFormPos(form)" (onClose)="onClose()">
    <div class="formHeader">
        {{translate('Marco_geografico')}}
    </div>
    <div style="float: left; overflow: hidden;" class="form">
        <div style="margin-top: 10px; float:left;">
            <div style="float:left; margin-top: 4px;">
                <input [(ngModel)]="visible" type="checkbox" (change)="onChangeVisible($event)" [disabled]="!canEdit" />
                {{translate('Ver')}}
            </div>
            <jqxButton style="float:left; margin-left: 10px;" [width]='100' [height]='26'
                [textImageRelation]='"imageBeforeText"' [textPosition]='"left"' [imgSrc]='"/assets/images/zonas.png"'
                (onClick)="onDefinir($event)" [value]="translate('Definir')" [disabled]="!canEdit">
            </jqxButton>
        </div>
        <div style="position:absolute; bottom:5px; left:4px; margin-top: 10px; clear: both;">
            <jqxButton style="float: left" [width]='100' [height]='26' [textImageRelation]='"imageBeforeText"'
                [textPosition]='"left"' [imgSrc]='"/assets/images/save.png"' (onClick)="onGuardar($event)"
                [value]="translate('Guardar')" [disabled]="!canEdit">
            </jqxButton>
        </div>
    </div>
</jqxWindow>